import { render, staticRenderFns } from "./DataInputSimulator.vue?vue&type=template&id=764d171c"
import script from "./DataInputSimulator.vue?vue&type=script&lang=js"
export * from "./DataInputSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764d171c')) {
      api.createRecord('764d171c', component.options)
    } else {
      api.reload('764d171c', component.options)
    }
    module.hot.accept("./DataInputSimulator.vue?vue&type=template&id=764d171c", function () {
      api.rerender('764d171c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/DataInputSimulator.vue"
export default component.exports